var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "wallet-table",
    {
      staticClass: "wallet-quota-table",
      attrs: {
        headList: _vm.headList,
        contentList: _vm.pledgeList,
        clickCell: _vm.clickCell
      }
    },
    [
      _vm._l(_vm.pledgeList, function(item, i) {
        return _c(
          "div",
          { key: i, attrs: { slot: i + "addrBefore" }, slot: i + "addrBefore" },
          [
            _c("span", { staticClass: "beneficial-addr" }, [
              _vm._v(_vm._s(item.showAddr))
            ]),
            _vm._v(" "),
            item.beneficialAddr === _vm.address
              ? _c("img", {
                  staticClass: "beneficial-img",
                  attrs: { src: require("assets/imgs/mine.svg") }
                })
              : _vm._e()
          ]
        )
      }),
      _vm._v(" "),
      _vm._l(_vm.pledgeList, function(item, i) {
        return _c(
          "span",
          {
            key: i,
            class: {
              cancel: true,
              active: item.isMaturity && !item.agent
            },
            attrs: { slot: i + "cancelBefore" },
            slot: i + "cancelBefore"
          },
          [_vm._v(_vm._s(_vm.$t("walletQuota.withdrawalStaking")))]
        )
      }),
      _vm._v(" "),
      _c("pagination", {
        staticClass: "__tb_pagination",
        attrs: {
          slot: "tableBottom",
          currentPage: _vm.currentPage + 1,
          totalPage: _vm.totalPage,
          toPage: _vm.toPage
        },
        slot: "tableBottom"
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }